export const MuiLinearProgress = {
    styleOverrides: {
        root: ({ theme }) => ({
            height: '.5rem',
            borderRadius: '9999px',
            backgroundColor: theme.palette.neutral.lighter,
        }),
        colorPrimary: {},
        bar: ({ theme }) => ({
            // TODO: to delete later (check if below case is working)
            // [`&.${linearProgressClasses.barColorPrimary}`]: {
            // 	backgroundColor: theme.palette.primary.dark,
            // },
            // [`&.${linearProgressClasses.barColorSecondary}`]: {
            // 	backgroundColor: theme.palette.secondary.dark,
            // },
            // // There  are no acceptable classes in linearProgressClasses! Only primary and secondary are allowed.
            // '&.MuiLinearProgress-barColorSuccess': {
            // 	backgroundColor: theme.palette.success.main,
            // },
            // '&.MuiLinearProgress-barColorError': {
            // 	backgroundColor: theme.palette.error.dark,
            // },
            // TODO: check if it is working after MUI V7 -> V9 upgrade
            variants: [
                { props: { color: 'primary' }, style: { backgroundColor: theme.palette.primary.dark } },
                { props: { color: 'secondary' }, style: { backgroundColor: theme.palette.secondary.dark } },
                { props: { color: 'success' }, style: { backgroundColor: theme.palette.success.main } },
                { props: { color: 'error' }, style: { backgroundColor: theme.palette.error.dark } },
            ],
        }),
    },
};
